import { useCallback, useEffect, useState } from 'react';

const BANNER_RATIO = 1.4;

function isBannerAspectRatio(width, height) {
  const w = Number(width);
  const h = Number(height);
  return w > 0 && h > 0 && w / h > BANNER_RATIO;
}

function detectBannerFromImageEvent(event) {
  const img = event?.target;
  if (!img?.naturalWidth) return false;
  return isBannerAspectRatio(img.naturalWidth, img.naturalHeight);
}

/** Layout from loaded image dimensions (no DB field). */
export function usePartnerLogoAspect(imageUrl) {
  const [isBanner, setIsBanner] = useState(false);

  useEffect(() => {
    setIsBanner(false);
  }, [imageUrl]);

  const onImageLoad = useCallback((event) => {
    if (!imageUrl) return;
    setIsBanner(detectBannerFromImageEvent(event));
  }, [imageUrl]);

  return { isBanner, onImageLoad };
}

export function getPartnerLogoPresentation(isBanner, surface) {
  if (isBanner) {
    if (surface === 'navbar') {
      return {
        className: 'rounded bg-white',
        style: { height: 48, maxWidth: 220, width: 'auto', objectFit: 'contain' },
      };
    }
    if (surface === 'report') {
      return {
        className: 'rounded bg-white object-contain',
        style: { height: 40, maxWidth: 200, minWidth: 120, width: 'auto' },
      };
    }
    if (surface === 'profile') {
      return {
        containerClassName:
          'rounded bg-white d-flex align-items-center justify-content-center position-relative flex-shrink-0 overflow-hidden border',
        containerStyle: { width: 200, height: 56 },
        imgClassName: 'w-100 h-100',
        imgStyle: { objectFit: 'contain', padding: 4 },
      };
    }
  }

  if (surface === 'navbar') {
    return {
      className: '',
      style: {
        width: 220,
        maxWidth: 'calc(100vw - 100px)',
        height: 60,
        maxHeight: 60,
        objectFit: 'contain',
      },
    };
  }
  if (surface === 'report') {
    return {
      className: 'h-10 w-10 rounded-full bg-white object-contain',
      style: {},
    };
  }
  return {
    containerClassName:
      'rounded-circle bg-primary text-white d-flex align-items-center justify-content-center position-relative flex-shrink-0 overflow-hidden',
    containerStyle: { width: 100, height: 100 },
    imgClassName: 'w-100 h-100',
    imgStyle: { objectFit: 'contain', padding: '8px' },
  };
}
